import axios from 'axios';
import _, { isNil, isEmpty, omitBy, toUpper, omit } from 'lodash';
import normalize from 'Utils/normalizer';
import { errorHandler } from '../utils';
import { getWithExpiry } from 'Helpers/getset-with-expiry';

type Filters = {
  _id?: string,
  fullName: string,
  address: {
    street1: string,
    street2: string,
    postcode: string,
    state: string,
    country: string
  }
}

//I didn't get rid of fetchUserProfile and updateUserProfile because profile.tsx is reliant on them
export const fetchUserProfile = async (profileID: any) => {
  const url = `${process.env.API_URL}/${process.env.API_VER}/dem/profile/fetch`;
  const session = getWithExpiry(process.env.APP_SESSION);
  const { accessToken } = session;

  try {
    const response = await axios({
      method: 'POST',
      url: url,
      data: { profileID: profileID },
      headers: { 'Authorization': `Bearer ${accessToken}` }
    });

    return normalize.model.profile(response.data.profile);
  }
  catch (err) {

    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await fetchUserProfile(profileID);
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack } };
    }
    else {
      return { error: { message: err.message } };
    }
  }
}

export const generatePassword = (length = 8) => {
  const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let retVal = '';

  for (let i = 0, n = charset.length; i < length; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n));
  }

  return retVal;
}

export const updateUserProfile = async (data: any) => {
  const url = `${process.env.API_URL}/${process.env.API_VER}/dem/profile/update`;
  const session = getWithExpiry(process.env.APP_SESSION);
  const { accessToken } = session;

  let logoBase64String = data.logoBase64String;
  try {
    const response = await axios({
      method: 'POST',
      url: url,
      data: omitBy({
        profile: normalize.response.profile(_.omit(data, ['logoBase64String'])),
        file: logoBase64String ? {
          fileName: toUpper(generatePassword()),
          fileType: 'IMAGE',
          base64String: logoBase64String
        } : null
      }, isNil),
      headers: { 'Authorization': `Bearer ${accessToken}` }
    });

    return !isEmpty(response.data.profile) ? normalize.model.profile(response.data.profile.new) : response;

  }
  catch (err) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await updateUserProfile(data);
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack } };
    }
    else {
      return { error: { message: err.message } };
    }
  }
}

// I used normalize.response.cmsProfile because it
// corresponds to app.drez.io's normalize.server.profile.profile

export async function createProfile(data: any, isIdentityUpload: boolean) {
  const url = `${process.env.CMS_API_URL}/RegisterNewPatient/?external=1`;

  try {
    const profile = await axios({
      method: 'POST',
      url: url,
      data: normalize.response.cmsProfile(data),
    });

    if (!isNil(profile)) {
      const decode = profile.split('|');

      const isSuccess = decode[0];
      const pid = decode[1];

      if (isSuccess == '1') {
        // if (isIdentityUpload) {
        //   // Separate API call for upload NRIC/Passport
        // const response: any = await updateProfileVerificationDocument(data);
        // if (!isNil(response.error)) {
        //   return errorHandler.cmsResponse('INTERNAL_SERVER_ERROR');
        // }
        //}



        return { ...data, pid };
      }
      else if (isSuccess == '0') {
        return errorHandler.cmsResponse('ACCOUNT_ALREADY_EXIST')
      }
      else {
        return errorHandler.cmsResponse('INTERNAL_SERVER_ERROR');
      }
    }

    return errorHandler.cmsResponse('INTERNAL_SERVER_ERROR');
  }
  catch (err) {
    return errorHandler.cmsResponse('INTERNAL_SERVER_ERROR');
  }
}

export async function getProfile(pid: string) {
  const url = `${process.env.CMS_API_URL}/GetPersonProfileInfo/${pid}?phr=1`;

  try {
    const response = await axios({
      method: 'GET',
      url: url
    });

  }
  catch (err) {
    return errorHandler.cmsResponse('INTERNAL_SERVER_ERROR');
  }
}

export const checkEmailExistsInCMS = async (email: string) => {
  const url = `${process.env.CMS_API_URL}/IsAccountRegistered/`;
  email = ('' + email).toLowerCase();

  try {
    const response = await axios({
      method: 'POST',
      url: url,
      data: `"${email}"`,
      headers: { 
        "Content-Type": "application/json"
      },
    });

    return response;
  }
  catch (err) {
    return false;
  }
}

export const updateUserProfileForChat = async (data: any) => {
  const url = `${process.env.CHAT_URL}/${process.env.API_VER}/user/update`;
  const session = getWithExpiry(process.env.APP_SESSION);
  const token = localStorage.getItem('CHAT_TOKEN')

  let logoBase64String = data.logoBase64String;
  console.log(data)
  try {
    const response = await axios({
      method: 'POST',
      url: url,
      data: omitBy({
        //profile: normalize.response.profile(_.omit(data, ['logoBase64String'])),
        user: {
          refID: data.profileID,
          types: ['USER'],
          nickName: data.fullName
        },
        file: logoBase64String ? {
          fileName: toUpper(generatePassword()),
          fileType: 'IMAGE',
          base64String: logoBase64String
        } : null
      }, isNil),
      headers: { 'Authorization': `Bearer ${token}` }
    });

    return !isEmpty(response.data.profile) ? normalize.model.profile(response.data.profile.new) : response;

  }
  catch (err) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await updateUserProfile(data);
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack } };
    }
    else {
      return { error: { message: err.message } };
    }
  }
}